var map = {
	"./": 9737,
	"./cs_CZ": 8347,
	"./cs_CZ.js": 8347,
	"./en_GB": 2488,
	"./en_GB.js": 2488,
	"./format-number": 2402,
	"./format-number.js": 2402,
	"./helpers": 1132,
	"./helpers.tsx": 1132,
	"./hu_HU": 1118,
	"./hu_HU.js": 1118,
	"./index": 9737,
	"./index.ts": 9737,
	"./phrases": 1983,
	"./phrases.js": 1983,
	"./pl_PL": 2936,
	"./pl_PL.js": 2936,
	"./sk_SK": 796,
	"./sk_SK.js": 796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5622;